import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonDirectiveModule } from '../../../../directives/button-directive/button-directive.module';
import { DataSelectorDirective } from '../../../../directives/data-selector/data-selector.directive';
import { SharedModule } from '../../../../shared.module';

@Component({
  selector: 'app-error-renderer',
  templateUrl: './error-renderer.component.html',
  styleUrls: ['./error-renderer.component.scss'],
  imports: [SharedModule, ButtonDirectiveModule, DataSelectorDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorRendererComponent {
  readonly message = input<string | null>(null);

  readonly retry = output<void>();

  protected onRetry(): void {
    this.retry.emit();
  }
}
